import { ActivityMisalignments, CalendarMode, MisalignmentItem, Row } from "PFApp/booking/types";
import { RowType } from "PFApp/booking/types/row";
import { ActivityWarningsIndex } from "PFCore/hooks/queries/activity";

import { getOriginalResource } from "../../helpers";

const getAllMisalignmentItems = (misalignments: ActivityMisalignments[number] = {}) =>
  Object.values(misalignments).flat();

export const getMisalignmentItemsByRow = (
  row: Row,
  warningsByActivity: ActivityWarningsIndex,
  parents: Row[] = []
): MisalignmentItem[] => {
  const { type = [] } = row;
  const originalResourceId = getOriginalResource(row, CalendarMode.Projects)?.id!;
  if (!warningsByActivity || !Object.keys(warningsByActivity).length) {
    return [];
  }
  switch (type) {
    case RowType.Role: {
      const roleMisalignments = getRoleMisalignments(originalResourceId, warningsByActivity);
      return getAllMisalignmentItems(Object.values(roleMisalignments));
    }
    case RowType.Profile: {
      const roleParentRow = parents.find((i) => i.type === RowType.Role);
      const roleId = roleParentRow ? getOriginalResource(roleParentRow, CalendarMode.Projects)?.id : null;
      const roleMisalignments = roleId ? getRoleMisalignments(roleId, warningsByActivity) : {};
      return (roleMisalignments[originalResourceId] || []) as MisalignmentItem[];
    }
    case RowType.Engagement:
    default:
      return [];
  }
};

const getRoleMisalignments = (
  roleId: number,
  warningsByActivity: ActivityWarningsIndex
): ActivityMisalignments[number] => warningsByActivity[roleId]?.misalignments || {};
